/* SEVN customizations */

/* ---- TUNING -------------------------------------------------------------
   Hero text nudge: bigger number = higher up (px).
-------------------------------------------------------------------------- */
var SEVN_HERO_SUBTEXT_UP_DESKTOP = 18;
var SEVN_HERO_BUTTON_UP_DESKTOP = 10;
var SEVN_HERO_SUBTEXT_UP_MOBILE = 14;
var SEVN_HERO_BUTTON_UP_MOBILE = 8;
var SEVN_MOBILE_ICON_WIDTH = 3.2;

/* Labels to strip off product cards. Sold out, Sale and Pre order stay. */
var SEVN_HIDE_LABELS = ['BEST SELLER'];

/* 1. Style overrides injected at runtime */
(function () {
  var css = [
    '@media screen and (max-width:749px){input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]),select,textarea{font-size:16px!important}}',
    /* A GIFT, ON US tab - right edge */
    '#sevn-gift-tab{left:auto!important;right:0!important;transform:translateY(-50%) translateX(120%)!important;border-left:1px solid #1A1A18!important;border-right:none!important}',
    '#sevn-gift-tab.is-in{transform:translateY(-50%) translateX(0)!important}',
    '#sevn-gift-tab .gt-open{transform:none!important}',
    /* wishlist heart */
    '.sevn-hi{display:none}',
    '.sevn-hi svg{width:20px;height:20px;display:block;fill:none;stroke:currentColor;stroke-width:1.15;stroke-linecap:round;stroke-linejoin:round}',
    /* My Capsule keeps the nav classes only so the theme colour rules reach it */
    'a.sevn-capsule{display:none;align-items:center;text-decoration:none;white-space:nowrap;background:none!important;border:0!important}',
    'a.sevn-capsule:after,a.sevn-capsule:before{display:none!important;content:none!important}',
    '@media screen and (min-width:990px){.sevn-hi{display:flex;align-items:center}a.sevn-capsule{display:inline-flex}}',
    /* hero text nudge - desktop */
    '@media screen and (min-width:990px){',
    '.banner__text{transform:translateY(-' + SEVN_HERO_SUBTEXT_UP_DESKTOP + 'px)}',
    '.banner__buttons{transform:translateY(-' + SEVN_HERO_BUTTON_UP_DESKTOP + 'px)}',
    '}',
    /* hero text nudge - mobile */
    '@media screen and (max-width:749px){',
    '.banner__text{transform:translateY(-' + SEVN_HERO_SUBTEXT_UP_MOBILE + 'px)}',
    '.banner__buttons{transform:translateY(-' + SEVN_HERO_BUTTON_UP_MOBILE + 'px)}',
    '}'
  ].join('');
  var s = document.createElement('style');
  s.textContent = css;
  (document.head || document.documentElement).appendChild(s);
})();

/* SEVN Klaviyo welcome disclosure */
(function () {
  var FORM_IDS = ['Ri5ziL', 'SnFyke'];
  var COPY = "We don't put luxury markups on our pieces, so we never need to mark them down. We believe in what we make: solid 14k gold, lab grown diamonds, pieces meant to live on you instead of in a box. One honest price, and we stand behind it. We're confident you'll love what arrives, so the only offer we ever make is a welcome.";
  var seenCapture = {};
  var submitted = {};
  var popupShells = {};
  var blankSuccessSeen = new WeakMap();

  function formId(form) {
    return (form.getAttribute('data-testid') || '').replace('klaviyo-form-', '');
  }

  function successContent() {
    var mobile = window.innerWidth <= 749;
    var wrap = document.createElement('div');
    wrap.setAttribute('data-sevn-success', '');
    wrap.style.cssText = 'display:flex;flex-direction:column;justify-content:center;align-items:center;width:100%;height:100%;box-sizing:border-box;text-align:center;';

    var headline = document.createElement('div');
    headline.style.cssText = 'margin:0;color:#1A1A18;font-family:"Bodoni Moda","Times New Roman",serif;font-size:28px;font-style:italic;font-weight:200;line-height:1.1;white-space:nowrap;';
    headline.textContent = 'Welcome to SEVN';

    var subcopy = document.createElement('div');
    subcopy.style.cssText = 'margin:16px 0 0;color:rgba(26,26,24,.75);font-family:Arial,sans-serif;font-size:' + (mobile ? '12px' : '14px') + ';font-weight:400;line-height:1.35;white-space:nowrap;';
    subcopy.textContent = 'Your code is on its way to your inbox.';

    var button = document.createElement('a');
    button.href = '/collections/all';
    button.style.cssText = 'display:flex;align-items:center;justify-content:center;width:100%;height:30px;box-sizing:border-box;margin:24px 0 0;border:0;border-radius:2px;background:#3E352A;color:#F9F2DC;font-family:Arial,sans-serif;font-size:12px;font-weight:400;line-height:1;letter-spacing:.25em;text-decoration:none;text-transform:uppercase;';
    button.textContent = 'SHOP THE COLLECTION';

    wrap.appendChild(headline);
    wrap.appendChild(subcopy);
    wrap.appendChild(button);
    return wrap;
  }

  function findPopupShell(form) {
    var node = form;
    for (var i = 0; node && i < 9; i++, node = node.parentElement) {
      var buttons = node.querySelectorAll ? node.querySelectorAll('button') : [];
      var hasClose = Array.prototype.some.call(buttons, function (button) {
        var label = (button.getAttribute('aria-label') || '').toLowerCase();
        return label.indexOf('close') !== -1 || button.textContent.trim() === String.fromCharCode(215);
      });
      var rect = node.getBoundingClientRect ? node.getBoundingClientRect() : { width: 0 };
      if (hasClose && rect.width > 250 && rect.width < 800) return node;
    }
    return null;
  }

  function installSuccess(form) {
    if (!form || form.querySelector('[data-sevn-success]')) return;

    var mobile = window.innerWidth <= 749;
    form.replaceChildren(successContent());
    form.style.setProperty('box-sizing', 'border-box', 'important');
    form.style.setProperty('height', mobile ? '280px' : '292px', 'important');
    form.style.setProperty('min-height', mobile ? '280px' : '292px', 'important');
    form.style.setProperty('display', 'flex', 'important');
    form.style.setProperty('flex-direction', 'column', 'important');
    form.style.setProperty('justify-content', 'center', 'important');
  }

  function installSuccessInShell(id) {
    var shell = popupShells[id];
    if (!shell || !shell.isConnected || shell.querySelector('[data-sevn-success-shell]')) return;
    if (shell.querySelector('input[type="email"]')) return;

    var mobile = window.innerWidth <= 749;
    var overlay = document.createElement('div');
    overlay.setAttribute('data-sevn-success-shell', '');
    overlay.style.cssText = 'position:absolute;inset:0;z-index:2;display:flex;box-sizing:border-box;padding:' + (mobile ? '30px 32px 26px' : '40px 44px 32px') + ';background:#FFFCF6;';
    overlay.appendChild(successContent());
    shell.style.setProperty('position', 'relative', 'important');
    shell.style.setProperty('height', mobile ? '280px' : '292px', 'important');
    shell.style.setProperty('min-height', mobile ? '280px' : '292px', 'important');
    shell.appendChild(overlay);

    Array.prototype.forEach.call(shell.querySelectorAll('button'), function (button) {
      var label = (button.getAttribute('aria-label') || '').toLowerCase();
      if (label.indexOf('close') !== -1 || button.textContent.trim() === String.fromCharCode(215)) {
        button.style.setProperty('z-index', '3', 'important');
      }
    });
  }

  function isCloseButton(button) {
    var label = (button.getAttribute('aria-label') || '').toLowerCase();
    return label.indexOf('close') !== -1 || button.textContent.trim() === String.fromCharCode(215);
  }

  function restorePersistedBlankSuccess() {
    var now = Date.now();
    var candidates = document.querySelectorAll('div,form');
    Array.prototype.forEach.call(candidates, function (candidate) {
      if (candidate.querySelector('[data-sevn-success], [data-sevn-success-shell]')) return;
      if (candidate.querySelector('input[type="email"]')) return;

      var rect = candidate.getBoundingClientRect();
      if (rect.width < 300 || rect.width > 800 || rect.height < 100 || rect.height > 450) return;
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;

      var style = window.getComputedStyle(candidate);
      var background = style.backgroundColor.replace(/\s/g, '');
      if (background !== 'rgb(255,252,246)' && background !== 'rgba(255,252,246,1)') return;

      var close = Array.prototype.find.call(candidate.querySelectorAll('button'), isCloseButton);
      if (!close) return;
      var remainingText = candidate.textContent.replace(/[×x]/gi, '').trim();
      if (remainingText) return;

      var firstSeen = blankSuccessSeen.get(candidate);
      if (!firstSeen) {
        blankSuccessSeen.set(candidate, now);
        return;
      }
      if (now - firstSeen < 1200) return;

      var mobile = window.innerWidth <= 749;
      var overlay = document.createElement('div');
      overlay.setAttribute('data-sevn-success-shell', '');
      overlay.style.cssText = 'position:absolute;inset:0;z-index:2;display:flex;box-sizing:border-box;padding:' + (mobile ? '30px 32px 26px' : '40px 44px 32px') + ';background:#FFFCF6;';
      overlay.appendChild(successContent());
      candidate.style.setProperty('position', 'relative', 'important');
      candidate.style.setProperty('height', mobile ? '280px' : '292px', 'important');
      candidate.style.setProperty('min-height', mobile ? '280px' : '292px', 'important');
      candidate.appendChild(overlay);
      close.style.setProperty('z-index', '3', 'important');
    });
  }

  function installForm(form) {
    if (!form || form.querySelector('[data-sevn-success]')) return;

    var id = formId(form);
    var email = form.querySelector('input[type="email"]');
    if (!email) {
      if (submitted[id] || (seenCapture[id] && !form.textContent.trim())) installSuccess(form);
      return;
    }
    seenCapture[id] = true;
    popupShells[id] = findPopupShell(form) || popupShells[id];
    if (form.querySelector('[data-sevn-welcome-disclosure]')) return;

    var paragraphs = Array.prototype.slice.call(form.querySelectorAll('p'));
    var subline = paragraphs.find(function (p) {
      return p.textContent.trim() === 'The one offer we make: a welcome.' ||
        p.textContent.indexOf('Sign up for $30 off your first order') !== -1;
    });
    if (!subline) return;
    subline.textContent = 'The one offer we make: a welcome.';

    var emailRow = email.closest('[data-testid="form-row"]');
    if (!emailRow || !emailRow.parentNode) return;
    var disclosureRow = emailRow.cloneNode(false);
    emailRow.parentNode.insertBefore(disclosureRow, emailRow);

    var wrap = document.createElement('div');
    wrap.setAttribute('data-sevn-welcome-disclosure', '');
    wrap.style.cssText = 'display:block;box-sizing:border-box;text-align:center;padding:0;margin:0;width:100%;';

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.style.cssText = 'display:block;width:auto;margin:0 auto;appearance:none;border:0;background:transparent;color:#776555;font:500 11px/1.4 Arial,sans-serif;letter-spacing:.25em;text-align:center;padding:0;cursor:pointer;text-transform:uppercase;';
    toggle.textContent = 'WHY ONLY ONCE ' + String.fromCharCode(8250);

    var panel = document.createElement('div');
    panel.hidden = true;
    panel.style.cssText = 'width:100%;box-sizing:border-box;margin:14px 0 0;padding:0 0 14px;text-align:left;';

    var copy = document.createElement('p');
    copy.style.cssText = 'margin:0 0 14px;text-align:left;color:rgba(26,26,24,.75);font:400 ' + (window.innerWidth <= 749 ? '12px' : '14px') + '/1.6 Arial,sans-serif;letter-spacing:0;';
    copy.textContent = COPY;

    var rule = document.createElement('div');
    rule.style.cssText = 'height:1px;background:rgba(203,193,181,.6);width:100%;';

    panel.appendChild(copy);
    panel.appendChild(rule);
    wrap.appendChild(toggle);
    wrap.appendChild(panel);
    disclosureRow.appendChild(wrap);
    disclosureRow.style.display = 'block';

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      var opening = panel.hidden;
      panel.hidden = !opening;
      toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      toggle.textContent = 'WHY ONLY ONCE ' + String.fromCharCode(opening ? 8964 : 8250);
    });

    var joinButton = Array.prototype.slice.call(form.querySelectorAll('button')).find(function (button) {
      return button.textContent.trim().toUpperCase() === 'JOIN';
    });
    if (joinButton) joinButton.style.setProperty('background-color', '#3E352A', 'important');
  }

  function install() {
    FORM_IDS.forEach(function (id) {
      installForm(document.querySelector('[data-testid="klaviyo-form-' + id + '"]'));
      if (submitted[id]) installSuccessInShell(id);
    });
    restorePersistedBlankSuccess();
  }

  new MutationObserver(install).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('klaviyoForms', function (event) {
    var detail = event.detail || {};
    if (detail.type === 'submit' && FORM_IDS.indexOf(detail.formId) !== -1) {
      submitted[detail.formId] = true;
      setTimeout(install, 0);
      setTimeout(install, 250);
      setTimeout(install, 750);
    }
    install();
  });
  document.addEventListener('submit', function (event) {
    FORM_IDS.forEach(function (id) {
      var form = document.querySelector('[data-testid="klaviyo-form-' + id + '"]');
      if (form && form.contains(event.target)) {
        popupShells[id] = findPopupShell(form) || popupShells[id];
      }
    });
  }, true);
  window.addEventListener('klaviyoForms', install);
  setInterval(install, 500);
  install();
})();

/* 2. Header: keep the static My Capsule link aligned with the desktop navigation. */
(function () {
  var TYPE = ['font-family', 'font-size', 'font-weight', 'font-style',
    'letter-spacing', 'text-transform', 'line-height'];

  function realNav() {
    var list = document.querySelectorAll('.header__inline-menu a, .header__menu-item:not(.sevn-capsule)');
    for (var i = 0; i < list.length; i++) {
      if (list[i].offsetParent && list[i].textContent.trim()) return list[i];
    }
    return null;
  }

  function syncType() {
    var capsules = document.querySelectorAll('.sevn-capsule');
    for (var i = capsules.length - 1; i > 0; i--) capsules[i].remove();

    var cap = capsules[0];
    var nav = realNav();
    if (!cap || !nav) return;

    var computed = window.getComputedStyle(nav);
    TYPE.forEach(function (property) {
      cap.style.setProperty(property, computed.getPropertyValue(property), 'important');
    });
    cap.style.setProperty('padding', '0 1.6rem 0 0', 'important');
    cap.style.setProperty('margin', '0', 'important');
    cap.style.setProperty('height', 'auto', 'important');
    cap.style.setProperty('min-height', '0', 'important');
  }

  if (document.readyState !== 'loading') syncType();
  document.addEventListener('DOMContentLoaded', syncType);
  window.addEventListener('load', syncType);
  window.addEventListener('resize', syncType);
  document.addEventListener('shopify:section:load', syncType);
})();

/* 3. Strip the BEST SELLER label from product cards.
   The theme uses one class, .new-label, for BEST SELLER, PRE ORDER, Sold out
   and Sale, so this matches on the wording and leaves the rest alone. */
(function () {
  var WANTED = SEVN_HIDE_LABELS.map(function (t) { return t.trim().toUpperCase(); });

  function strip(root) {
    (root || document).querySelectorAll('.new-label').forEach(function (el) {
      if (el.dataset.sevnChecked) return;
      el.dataset.sevnChecked = '1';
      if (WANTED.indexOf(el.textContent.trim().toUpperCase()) > -1) el.remove();
    });
  }

  if (document.readyState !== 'loading') strip();
  document.addEventListener('DOMContentLoaded', function () { strip(); });
  window.addEventListener('load', function () { strip(); });
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { strip(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* 4. Zoom handling. */
(function () {
  ['gesturestart', 'gestureend'].forEach(function (t) {
    window.addEventListener(t, function (e) { e.stopPropagation(); }, { capture: true, passive: false });
  });
  window.addEventListener('gesturechange', function (e) {
    e.stopPropagation();
    if (e.scale > 1) e.preventDefault();
  }, { capture: true, passive: false });
  window.addEventListener('touchmove', function (e) {
    if (e.touches && e.touches.length > 1) e.stopPropagation();
  }, { capture: true, passive: false });
})();
